<script lang="ts">
	import { Mask, type MaskInputOptions } from 'maska';
	import { maska } from 'maska/svelte';
	import { untrack } from 'svelte';

	interface Props {
		value: number | undefined;
		id?: string | undefined;
		name?: string;
		label?: string | undefined;
		errors?: string[] | undefined;
		placeholder?: string;
		labelClass?: string;
		inputClass?: string;
		type?: 'number' | 'currency';
		fraction?: number;
		currency?: string;
		class?: string;
		onInput?: (val: number) => void;
	}

	let {
		value = $bindable(),
		id,
		name = '',
		label,
		errors = [],
		placeholder = '',
		labelClass = 'mb-3 block index-bold',
		inputClass = 'input',
		type = 'number',
		fraction = 0,
		currency = 'SGD',
		class: clazz = '',
		onInput
	}: Props = $props();

	const options: MaskInputOptions = {
		number: {
			locale: 'default',
			fraction
		},
		...(type === 'currency'
			? {
					postProcess: (val) => {
						if (!val) return '';
						const currencySymbol = (0).toLocaleString('default', {
							style: 'currency',
							currency,
							currencyDisplay: 'narrowSymbol'
						})[0];
						return currency === 'SGD' ? `S${currencySymbol}${val}` : `${currencySymbol}${val}`;
					}
				}
			: {})
	};

	let inputValue: string = $state(value?.toString() ?? '');
	let mask = $derived(new Mask(options));

	$effect(() => {
		if (value)
			untrack(() => {
				if (value !== Number(mask.unmasked(inputValue)))
					inputValue =
						type === 'currency'
							? `S$${mask.masked(value!.toString())}`
							: mask.masked(value!.toString());
			});
	});
</script>

<div class="{errors?.length ? 'error' : ''} {clazz}">
	{#if label}
		<label for={id} class={labelClass}>
			{label}
		</label>
	{/if}

	<input
		bind:value={inputValue}
		use:maska={options}
		{id}
		{name}
		type="text"
		class={inputClass}
		{placeholder}
		oninput={(event) => {
			const target = event.target as HTMLInputElement;
			if (value !== Number(mask.unmasked(target.value))) {
				value = Number(mask.unmasked(target.value));
				if (onInput) onInput(value);
			}
		}}
	/>
	{#each errors ?? [] as message}
		<p class="message mt-2 text-sm">{message}</p>
	{/each}
</div>

<style lang="postcss">
	@reference '../app.css';

	.error {
		.message {
			@apply text-red-ticker;
		}

		input {
			@apply border-red-ticker border-2;
		}
	}
</style>
